import { Turret } from "./Turret";
import { GameConstants } from "../GameConstants";
import { MathUtils } from "../utils/MathUtils";
import { Mine } from "./shots/Mine";
import { Engine } from "../Engine";

export class MinesTurret extends Turret {

    public explosionRange: number;
    public numMines: number;
    public maxNumMines: number;

    
  
    constructor (p: {r: number, c: number}, engine: Engine, skipBuild?: boolean, level?: number) {
        
        super(GameConstants.TURRET_MINES, p, engine, skipBuild, level);

        this.calculateTurretParameters();

        this.numMines = 0;
        this.throwsMines = true;
      
        this.projectileSpeed = GameConstants.MORTAR_SPEED;
    }

    protected calculateTurretParameters(): void {

        this.damage = this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_DAMAGE][this.level - 1];
        this.explosionRange = this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_EXPLOSION_RANGE][this.level - 1];
        this.reload = this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_RELOAD][this.level - 1];
        this.range =  this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_RANGE][this.level - 1];
        this.priceUpgrade =  this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_PRICE_UPGRADE][this.level - 1];
        this.maxNumMines = this.engine.turretData[this.type].attributes[GameConstants.ATTRIBUTE_MAX_NUM_MINES][this.level - 1];

        super.calculateTurretParameters();
    }

    protected getPathCellsInRange(): {r: number, c: number}[] {

        let cells = [];

        for (let i = 0; i < this.engine.enemiesPathsCells.length; i++) {
            for (let j = 0; j < this.engine.enemiesPathsCells[i].path.length; j++) {

                let cell = this.engine.enemiesPathsCells[i].path[j];

                if (cell.c >= this.position.c && cell.c <= this.position.c + this.range ||
                    cell.c <= this.position.c && cell.c >= this.position.c - this.range) {

                        if (cell.r >= this.position.r && cell.r <= this.position.r + this.range ||
                            cell.r <= this.position.r && cell.r >= this.position.r - this.range) {

                                cells.push(cell);
                            }
                }
            }
        }

        return cells;
    }


    protected isInsidePathCell(mine: {c: number, r: number}): boolean {

        for (let i = 0; i < this.engine.mines.length; i++) {

            let otherMine = this.engine.mines[i];

            if (mine.c + .5 <= otherMine.x + .2 && mine.c + .5 >= otherMine.x - .2 && mine.r + .5 <= otherMine.y + .2 && mine.r + .5 >= otherMine.y - .2) {
                return false;
            }
        }

        for (let i = 0; i < this.engine.enemiesPathsCells.length; i++) {
            for (let j = 0; j < this.engine.enemiesPathsCells[i].path.length; j++) {

                let cell = this.engine.enemiesPathsCells[i].path[j];

                if (mine.c <= cell.c + .25 && mine.c >= cell.c - .25 && mine.r <= cell.r + .25 && mine.r >= cell.r - .25) {
                    return true;
                }
            }
        }

        return false;
    }

    protected shoot(): void {

        if (this.numMines < this.maxNumMines) {

            var angle = Math.random() * Math.PI * 2;

            let cell = {c: this.position.c + Math.sin(angle) * this.range * Math.random(), r: this.position.r + Math.cos(angle) * this.range * Math.random()};

            while (!this.isInsidePathCell(cell)) {
                angle = Math.random() * Math.PI * 2;
                cell = {c: this.position.c + Math.sin(angle) * this.range * Math.random(), r: this.position.r + Math.cos(angle) * this.range * Math.random()};
            }

            this.numMines++;

            const mine = new Mine({c: cell.c, r: cell.r}, this.explosionRange, this.damage, this, this.engine);
            this.engine.addMine(mine, this);

        } else {
            this.readyToShoot = true;
        }
    }
}
